import { Profil } from "@repo/types";
import { useDebounce } from "@repo/ui/hooks/use-debounce";
import { useState } from "react";
import { FormField } from "../../../components/ui/form";
import { useProfils } from "../../../hooks/api/profil";
import { EntitySelector } from "./entity-selector";

interface ProfileSelectorProps {
  control: any;
  name: string;
  fieldError?: string;
}

export function ProfileSelector({ control, name, fieldError }: ProfileSelectorProps) {
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  const { data: profilsData, isLoading } = useProfils({
    name: debouncedSearchTerm || undefined,
    page: 1,
    limit: 100,
    sortBy: "recent",
    includeDeleted: false,

  });

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <EntitySelector<Profil>
          name="profil"
          label="Profil"
          placeholder="Rechercher un profil..."
          data={profilsData?.data || []}
          isLoading={isLoading}
          value={field.value}
          onChange={field.onChange}
          hasError={!!fieldError}
          errorMessage={fieldError}
          getItemId={(profil) => profil.id}
          getItemName={(profil) => profil.name || ''}
          renderLabel={(profil) => <span>{profil.name || 'Sans nom'}</span>}
          onSearch={handleSearch}
          searchTerm={searchTerm}
          serverSideSearch={true}
          totalItems={profilsData?.total || 0}
        />
      )}
    />
  );
}
